/* tslint:disable */
/* eslint-disable */
/**
 * Kontor API
 * OpenAPI specification for Kontor application framework
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BlogList,
    BlogListFromJSON,
    BlogListToJSON,
    BlogObject,
    BlogObjectFromJSON,
    BlogObjectToJSON,
    Errors,
    ErrorsFromJSON,
    ErrorsToJSON,
    HtmlMenuList,
    HtmlMenuListFromJSON,
    HtmlMenuListToJSON,
    HtmlMenuObject,
    HtmlMenuObjectFromJSON,
    HtmlMenuObjectToJSON,
    HtmlMeta,
    HtmlMetaFromJSON,
    HtmlMetaToJSON,
    HtmlPageList,
    HtmlPageListFromJSON,
    HtmlPageListToJSON,
    HtmlPageObject,
    HtmlPageObjectFromJSON,
    HtmlPageObjectToJSON,
} from '../models';

export interface BlogIdGetRequest {
    id: string;
}

export interface HtmlmenuIdGetRequest {
    id: string;
}

export interface HtmlpageIdGetRequest {
    id: string;
}

/**
 * 
 */
export class CMSApi extends runtime.BaseAPI {

    /**
     * Load all available blog items.
     */
    async blogGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<BlogList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogListFromJSON(jsonValue));
    }

    /**
     * Load all available blog items.
     */
    async blogGet(initOverrides?: RequestInit): Promise<BlogList> {
        const response = await this.blogGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Load a specific blog item.
     */
    async blogIdGetRaw(requestParameters: BlogIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BlogObject>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling blogIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blog/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogObjectFromJSON(jsonValue));
    }

    /**
     * Load a specific blog item.
     */
    async blogIdGet(requestParameters: BlogIdGetRequest, initOverrides?: RequestInit): Promise<BlogObject> {
        const response = await this.blogIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Load all defined website navigation menues.
     */
    async htmlmenuGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<HtmlMenuList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/htmlmenu`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HtmlMenuListFromJSON(jsonValue));
    }

    /**
     * Load all defined website navigation menues.
     */
    async htmlmenuGet(initOverrides?: RequestInit): Promise<HtmlMenuList> {
        const response = await this.htmlmenuGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Load a specific navigation menu.
     */
    async htmlmenuIdGetRaw(requestParameters: HtmlmenuIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<HtmlMenuObject>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling htmlmenuIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/htmlmenu/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HtmlMenuObjectFromJSON(jsonValue));
    }

    /**
     * Load a specific navigation menu.
     */
    async htmlmenuIdGet(requestParameters: HtmlmenuIdGetRequest, initOverrides?: RequestInit): Promise<HtmlMenuObject> {
        const response = await this.htmlmenuIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Provides all HTML meta tags for website served by current Kontor server.
     */
    async htmlmetaGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<HtmlMeta>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/htmlmeta`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HtmlMetaFromJSON(jsonValue));
    }

    /**
     * Provides all HTML meta tags for website served by current Kontor server.
     */
    async htmlmetaGet(initOverrides?: RequestInit): Promise<HtmlMeta> {
        const response = await this.htmlmetaGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Load all available HTML pages.
     */
    async htmlpageGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<HtmlPageList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/htmlpage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HtmlPageListFromJSON(jsonValue));
    }

    /**
     * Load all available HTML pages.
     */
    async htmlpageGet(initOverrides?: RequestInit): Promise<HtmlPageList> {
        const response = await this.htmlpageGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Load a specific HTML page.
     */
    async htmlpageIdGetRaw(requestParameters: HtmlpageIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<HtmlPageObject>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling htmlpageIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/htmlpage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HtmlPageObjectFromJSON(jsonValue));
    }

    /**
     * Load a specific HTML page.
     */
    async htmlpageIdGet(requestParameters: HtmlpageIdGetRequest, initOverrides?: RequestInit): Promise<HtmlPageObject> {
        const response = await this.htmlpageIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
